// 不展示 Loading 的接口
export const urlsWithoutLoading = [
	'category/info/holidays',
	'train/order/orderDetail',
	// 'train/queryLeftTicket',
	'train-toc/order/orderDetail',
	'train-toc/serviceNotice',
	'train-toc/holidays',
	'train-toc/queryCityList',
	'train-toc/common/home',
	'train-toc/common/existValidateUserAccount',
	'train-toc/common/getAllUserAccount',
	'train-toc/coupon/getCouponList',
	'train-toc/queryLeftTicket',
	'train-toc/multiQueryTrainNoList',
	'train-toc/estimate',
	'train-toc/makePay',
	'train-toc/user/reverse',
	'resapi/activity/mget',
	'train-toc/common/getCheckedProtocol',
	'train-toc/order/homePageList',
	'train-toc/getApolloConfig',
	'train-toc/package/accelerateDetail',
	'train-toc/common/rememberCheckedProtocol',
  'train-api/poster/generatePainter',
	// 机票
	'flight-api/get_all_citys',
	'flight-api/discount_flight_tickets',
	'resapi/activity/mget',
	'activity-api/auth/coupon/query_coupon_list',
	'search-api/gray_check',
	'search-api/one_way/get_price_calender',
	'train-api/common/rememberCheckedProtocol',
]

//无需强制依赖token的接口
export const urlsWithoutToken = [
	'train-toc/holidays',
	'train-toc/queryCityList',
	'train-toc/queryCityStationNameByKeyword',
	'train-toc/queryLeftTicket',
	'train-toc/coupon/getCouponList'
]